import { addDays, format, parseISO } from "date-fns";

export function formatWeekRange(weekStart: string): string {
  const start = parseISO(weekStart);
  const end = addDays(start, 6);
  return `${format(start, "MMM d")} – ${format(end, "MMM d, yyyy")}`;
}

export function formatMonthLabel(monthStart: string): string {
  return format(parseISO(monthStart), "MMMM yyyy");
}

export function formatQuarterLabel(quarterStart: string): string {
  const date = parseISO(quarterStart);
  const quarter = Math.floor(date.getMonth() / 3) + 1;
  return `Q${quarter} ${format(date, "yyyy")}`;
}
